document.addEventListener("DOMContentLoaded", function() {
    const derivativetabs = document.querySelector('.derivative-tabs');
    if (!derivativetabs) return;

    const tabButtons = derivativetabs.querySelectorAll('button[data-info]');

    tabButtons.forEach(button => {
        button.addEventListener('click', () => {
            tabButtons.forEach(btn => btn.classList.remove('active-tab'));
            button.classList.add('active-tab');

            const infoId = button.getAttribute('data-info');

            document.querySelectorAll('.derivative-info').forEach(info => {
                info.classList.add('hidden');
            });

            console.log(infoId);

            const targetInfo = document.getElementById(infoId);
            if (targetInfo) {
                targetInfo.classList.remove('hidden');
            }
        });
    });

    moveTabContent();
});


    function moveTabContent() {
      for (let i = 1; i <= 5; i++) {
        const tab = document.getElementById(`tab-${i}`);
        const desktopHolder = document.getElementById('tab-desktop-holder');
        const mobileHolder = document.getElementById(`tab-${i}-mobile-holder`);

        if (!tab || !desktopHolder || !mobileHolder) continue;

        if (window.innerWidth > 768) {
          // Move to desktop holder
          if (!desktopHolder.contains(tab)) {
            desktopHolder.appendChild(tab);
          }
        } else {
          // Move to mobile holder
          if (!mobileHolder.contains(tab)) {
            mobileHolder.appendChild(tab);
          }
        }
      }
    }

 let resizeTimeout;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      moveTabContent();
    }, 150); // Adjust delay as needed
  });

  
  document.addEventListener('DOMContentLoaded', () => {
    const specContainer = document.getElementById('specification');

    if (!specContainer) return;

    specContainer.querySelectorAll('[data-toggle="accordion"]').forEach(button => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-accordion');
        const content = specContainer.querySelector(`#${targetId}`);

        if (content) {
          content.classList.toggle('hidden');
          button.querySelector('.caret-icon')?.classList.toggle('rotate-180');
        }
      });
    });


    const technicalContainer = document.getElementById('technical');
    if (!technicalContainer) return;
    technicalContainer.querySelectorAll('[data-toggle="accordion"]').forEach(button => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-accordion');
        const content = technicalContainer.querySelector(`#${targetId}`);

        if (content) {
          content.classList.toggle('hidden');
          button.querySelector('.caret-icon')?.classList.toggle('rotate-180');
        }
      });
    });

  });


  // Also run once on initial load
  window.addEventListener('DOMContentLoaded', moveTabContent);


// FAQ PAGE TABS
document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.scroll-to');

    buttons.forEach(button => {
      button.addEventListener('click', function () {
        const targetId = this.getAttribute('data-id');
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  });
